import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';
import { RuntimeService } from '../app/shared/services/runtime.service';
import { AuthService } from '../app/auth/services/auth.service';
import { NetworkStatusService } from '../app/shared/services/network-status.service';

const EXCLUDED_URLS = ['/api/login', '/api/forgot-password', '/api/fatclient/authenticate'];

export const interceptorInterceptor: HttpInterceptorFn = (req, next) => {

  const toastr = inject(ToastrService);
  const runtimeService = inject(RuntimeService);
  const authService = inject(AuthService);
  const networkStatusService = inject(NetworkStatusService);

  const isExcluded = EXCLUDED_URLS.some(url =>
    req.url.includes(url)
  );

  let authReq = req.clone({
    setHeaders: {
      'X-Client-Type': runtimeService.IsDesktopApplication ? 'FAT' : 'WB',
      ...(runtimeService.IsDesktopApplication && {
        'X-Is-Online': String(networkStatusService.isOnline)
      })
    }
  });
  console.log("authReq-->",authReq);
  
  if (isExcluded) {
    return next(authReq);
  }

  const token = localStorage.getItem('auth_token');
  if (token) {
    authReq = authReq.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }
  return next(authReq)
};
